// @flow
import React from 'react';
import LeadCarouselContainer from './LeadCarouselContainer';
import {ErrorReportBoundary} from '@homeaway/react-error-reporter';
import logger from '../../utils/clientLogger';

type Props = {
    placement: string,
    resultCount: number,
    results: Object,
    percentBooked: number,
    showMabCarousels?: boolean,
    isLoadingOrRedirecting?: boolean
};

const LeadCarouselContainerWrapper = (props: Props) => {
    if (!props.results) {
        return null;
    }

    return (
        <ErrorReportBoundary
            name={'LeadCarouselContainerWrapper Error'}
            onError={(error, info) => {
                logger.captureException(error, {extra: info});
            }}
        >
            <LeadCarouselContainer {...props} />
        </ErrorReportBoundary>
    );
};

export default LeadCarouselContainerWrapper;
